import { render, staticRenderFns } from "./main_posts.vue?vue&type=template&id=4bd869f7&scoped=true&"
import script from "./main_posts.vue?vue&type=script&lang=js&"
export * from "./main_posts.vue?vue&type=script&lang=js&"
import style0 from "./main_posts.vue?vue&type=style&index=0&id=4bd869f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd869f7",
  null
  
)

export default component.exports